module.exports = __webpack_public_path__ + "img/Israel_Electric_Corporation.5fdf5f62.svg";